// If considering jQuery, Make sure to use document ready or window.onload for StorybookJS to hook into events
(function($, drupalSettings) {

	Drupal.behaviors.garageTabs = {
		attach: function(context) {
			let body = document.querySelector('body'),
				tabs = document.querySelectorAll('.js-garage-tab', context);

			if( ! tabs ) {
				return false;
			}

			tabs.forEach(function(tab) {
				tab.addEventListener('click', function() {
					let tabDataAttr = this.dataset.section,
						currentTab = document.querySelector('.js-garage-tab.is-active'),
						section = document.querySelector('.js-section-rates[data-section=' + tabDataAttr + ']'),
						currentSection = document.querySelector('.js-section-rates.is-active'),
						sectionSharing = document.querySelector('.js-section-sharing[data-section=' + tabDataAttr + ']'),
						currentSectionSharing = document.querySelector('.js-section-sharing.is-active');

					currentTab.classList.remove('is-active');
					tab.classList.add('is-active');

					currentSection.classList.remove('is-active');
					section.classList.add('is-active');

					if( tabDataAttr === 'sharing' ) {
						sectionSharing.classList.add('is-active');
					} else if( currentSectionSharing ) {
						currentSectionSharing.classList.remove('is-active');
					}

					const switchBrand = new CustomEvent('switchbrand', {
						'detail': {
							brand: tabDataAttr
						}
					});

					document.dispatchEvent(switchBrand);
				});
			});
		}
	};

	Drupal.behaviors.liveStatus = {
		attach: function(context) {
			let elm = document.querySelector('.js-live-status');

			const liveCaller = function() {
				$.get(drupalSettings.liveStatusEndpoint).then(function(response) {

					console.log(response.status);

					if( response.status ) {

						if(response.status === 'vacant'){
							elm.classList.add('status-vacant');
							elm.innerHTML = Drupal.t('Short-term parking spaces available', {}, {'context': 'Bip Garage App'});
						}

						if(response.status === 'full'){
							elm.classList.add('status-full');
							elm.innerHTML = Drupal.t('No short-term parking spaces available', {}, {'context': 'Bip Garage App'});
						}
						if(response.status === 'no_short_stay_parking'){
							elm.classList.add('status-no-short');
							elm.innerHTML = Drupal.t('Only long-term parking', {}, {'context': 'Bip Garage App'});
						}

					}
					if( response.timestamp ) {
						const date = new Date(response.timestamp * 1000);
						document.querySelector('.js-live-status-timestamp').innerHTML = Drupal.t('Last Update: ', {}, {'context': 'Bip Garage App'}) + date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
					}
				});
			};
			liveCaller();
			setInterval(liveCaller, 1000 * 60);
		}
	};
}(jQuery, drupalSettings));